import React from 'react';

export default function LogoutIcon() {
  return (
    <span>
      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <g
          id="logout"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round">
          <g id="Icon-/-Black-/-Logout" stroke="#D22052" strokeWidth="2">
            <polyline
              id="Line"
              points="12 16 12 19 5 19 5 5 12 5 12 8"></polyline>
            <path d="M17,12 L9,12 L17,12 Z" id="Line"></path>
            <polyline id="Line" points="16 9 18 12 16 15"></polyline>
          </g>
        </g>
      </svg>
    </span>
  );
}
